// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.nkl-card {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  background: #fff;
  border-radius: 2px;
}
.nkl-card-rtl {
  direction: rtl;
}
.nkl-card-hoverable {
  cursor: pointer;
  transition: box-shadow 0.3s, border-color 0.3s;
}
.nkl-card-hoverable:hover {
  border-color: transparent;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
}
.nkl-card-bordered {
  border: 1px solid #f0f0f0;
}
.nkl-card-head {
  min-height: 48px;
  margin-bottom: -1px;
  padding: 0 24px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  background: transparent;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
}
.nkl-card-head::before {
  display: table;
  content: '';
}
.nkl-card-head::after {
  display: table;
  clear: both;
  content: '';
}
.nkl-card-head-wrapper {
  display: flex;
  align-items: center;
}
.nkl-card-head-title {
  display: inline-block;
  flex: 1;
  padding: 16px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.nkl-card-head-title > .nkl-typography,
.nkl-card-head-title > .nkl-typography-edit-content {
  left: 0;
  margin-top: 0;
  margin-bottom: 0;
}
.nkl-card-head .nkl-tabs-top {
  clear: both;
  margin-bottom: -17px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: normal;
  font-size: 14px;
}
.nkl-card-head .nkl-tabs-top-bar {
  border-bottom: 1px solid #f0f0f0;
}
.nkl-card-extra {
  margin-left: auto;
  padding: 16px 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: normal;
  font-size: 14px;
}
.nkl-card-rtl .nkl-card-extra {
  margin-right: auto;
  margin-left: 0;
}
.nkl-card-body {
  padding: 24px;
}
.nkl-card-body::before {
  display: table;
  content: '';
}
.nkl-card-body::after {
  display: table;
  clear: both;
  content: '';
}
.nkl-card-contain-grid .nkl-card-body {
  display: flex;
  flex-wrap: wrap;
}
.nkl-card-contain-grid:not(.nkl-card-loading) .nkl-card-body {
  margin: -1px 0 0 -1px;
  padding: 0;
}
.nkl-card-grid {
  width: 33.33%;
  padding: 24px;
  border: 0;
  border-radius: 0;
  box-shadow: 1px 0 0 0 #f0f0f0, 0 1px 0 0 #f0f0f0, 1px 1px 0 0 #f0f0f0, 1px 0 0 0 #f0f0f0 inset, 0 1px 0 0 #f0f0f0 inset;
  transition: all 0.3s;
}
.nkl-card-grid-hoverable:hover {
  position: relative;
  z-index: 1;
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
}
.nkl-card-contain-tabs > .nkl-card-head .nkl-card-head-title {
  min-height: 32px;
  padding-bottom: 0;
}
.nkl-card-contain-tabs > .nkl-card-head .nkl-card-extra {
  padding-bottom: 0;
}
.nkl-card-bordered .nkl-card-cover {
  margin-top: -1px;
  margin-right: -1px;
  margin-left: -1px;
}
.nkl-card-cover > * {
  display: block;
  width: 100%;
}
.nkl-card-cover img {
  border-radius: 2px 2px 0 0;
}
.nkl-card-actions {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}
.nkl-card-actions::before {
  display: table;
  content: '';
}
.nkl-card-actions::after {
  display: table;
  clear: both;
  content: '';
}
.nkl-card-actions > li {
  margin: 12px 0;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
}
.nkl-card-actions > li > span {
  position: relative;
  display: block;
  min-width: 32px;
  font-size: 14px;
  line-height: 1.5715;
  cursor: pointer;
}
.nkl-card-actions > li > span:hover {
  color: #1890ff;
  transition: color 0.3s;
}
.nkl-card-actions > li > span a:not(.nkl-btn),
.nkl-card-actions > li > span > .anticon {
  display: inline-block;
  width: 100%;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  transition: color 0.3s;
}
.nkl-card-actions > li > span a:not(.nkl-btn):hover,
.nkl-card-actions > li > span > .anticon:hover {
  color: #1890ff;
}
.nkl-card-actions > li > span > .anticon {
  font-size: 16px;
  line-height: 22px;
}
.nkl-card-actions > li:not(:last-child) {
  border-right: 1px solid #f0f0f0;
}
.nkl-card-rtl .nkl-card-actions > li:not(:last-child) {
  border-right: none;
  border-left: 1px solid #f0f0f0;
}
.nkl-card-type-inner .nkl-card-head {
  padding: 0 24px;
  background: #fafafa;
}
.nkl-card-type-inner .nkl-card-head-title {
  padding: 12px 0;
  font-size: 14px;
}
.nkl-card-type-inner .nkl-card-body {
  padding: 16px 24px;
}
.nkl-card-type-inner .nkl-card-extra {
  padding: 13.5px 0;
}
.nkl-card-meta {
  display: flex;
  margin: -4px 0;
}
.nkl-card-meta::before {
  display: table;
  content: '';
}
.nkl-card-meta::after {
  display: table;
  clear: both;
  content: '';
}
.nkl-card-meta-avatar {
  padding-right: 16px;
}
.nkl-card-rtl .nkl-card-meta-avatar {
  padding-right: 0;
  padding-left: 16px;
}
.nkl-card-meta-detail {
  flex: 1;
  overflow: hidden;
}
.nkl-card-meta-detail > div:not(:last-child) {
  margin-bottom: 8px;
}
.nkl-card-meta-title {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.nkl-card-meta-description {
  color: rgba(0, 0, 0, 0.45);
}
.nkl-card-loading {
  overflow: hidden;
}
.nkl-card-loading .nkl-card-body {
  user-select: none;
}
.nkl-card-small > .nkl-card-head {
  min-height: 36px;
  padding: 0 12px;
  font-size: 14px;
}
.nkl-card-small > .nkl-card-head > .nkl-card-head-wrapper > .nkl-card-head-title {
  padding: 8px 0;
}
.nkl-card-small > .nkl-card-head > .nkl-card-head-wrapper > .nkl-card-extra {
  padding: 8px 0;
  font-size: 14px;
}
.nkl-card-small > .nkl-card-body {
  padding: 12px;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
